import React, { useState, useEffect } from "react";
import { Tab } from "react-bootstrap";
import { withRouter, Link } from "react-router-dom";
import { EmployeeConfigService } from "../../../../service/employeeConfigService";

const ViewMaritalStatuses = () => {
  const [maritalStatuses, setMaritalStatuses] = useState(null);

  useEffect(() => {
    EmployeeConfigService.getMaritalStatuses()
      .then((response) => {
        console.log(response.data);
        setMaritalStatuses(response.data.data);
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  }, []);

  return (
    <div>
      <div className="row">
        <div className="tab-custom-pills-horizontal col-md-12">
          <div className="float-left">
            <span className="card-description"> Marital Statuses</span>{" "}
            &nbsp;&nbsp;&nbsp;
            <small className="card-description">
              <i>( Click on the box for details )</i>
            </small>
          </div>
          <div className="float-right">
            <span>
              <Link to={"/system-configuration/employee"}>
                Employee configuration
              </Link>
            </span>
            &nbsp;&nbsp;&nbsp;
            <Link to={"/employee-configuration/marital-statuses"}>
              <button type="button" className="btn btn-primary btn-rounded">
                Create Marital Status
              </button>
            </Link>
          </div>
        </div>
        <div className="clearfix"></div>
      </div>

      <div className="mt-3">
        <Tab.Pane eventKey="state">
          <div className="row">
            {maritalStatuses &&
              maritalStatuses.map((value, index) => (
                <div className="col-md-3 mb-5" key={index}>
                  <div className="domainBox">
                    <Link
                      to={`/employee-configuration/view-marital-status/${value.id}`}
                    >
                      <div className="react-aspect-ratio-placeholder">
                        <div className="sc-fzoiQi ozSmQ  ">
                          <main style={{ position: "relative" }}>
                            <h4 className="config-title"> {value.name}</h4>
                            <p>
                              {" "}
                              {value.description} <br />
                              {/* <small>{value.state}</small> */}
                            </p>
                          </main>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
          </div>
        </Tab.Pane>
      </div>
    </div>
  );
};

export default withRouter(ViewMaritalStatuses);
